module.exports = __webpack_public_path__ + "img/pin_big.37184c16.png";